<template>
  <router-view />
</template>

<script>
  export default {
    name: "TurnaroundSingle"
  }
</script>